module.exports = __webpack_public_path__ + "img/correo.fafbe9a4.svg";